module.exports = __webpack_public_path__ + "static/img/ttr03.6c94530.png";